var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-empty-tips",style:({height: _vm.height})},[_c('div',{staticClass:"tips"},[_vm._v(_vm._s(_vm.text || _vm.$t('Common.com_no_data')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }